import React from "react";
import PracticsQuestionTopics from "../../topics/PracticsQuestionTopics";


function PracticeQuestionsChemTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="chemistry" type="dpp" />

    </>
  );
}

export default PracticeQuestionsChemTopics;